var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"service-fixed",on:{"click":_vm.serviceShow}}),_vm._v(" "),_c('serviceDialog',{ref:"serviceDialog",attrs:{"imgSrc":"https://assets.pfotoo.com/images/version/qrcode-qy-0412.png"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7637d40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-fixed.vue
// module id = null
// module chunks = 